import type { IngestedEventSample } from '@weft/types'; 
import React from 'react';
import type { VyTableMinimalProps } from '../../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import { EVENTS_TABLE_COLUMNS } from './events-table-consts/events-columns';

export const EventsTable: React.FC<VyTableMinimalProps<IngestedEventSample>> = ({
  items,
  itemsCount,
  loadingItems,
  ...props
}) => {
  return (
    <>
      <VyTable
        itemsCount={itemsCount}
        items={items}
        columns={EVENTS_TABLE_COLUMNS}
        loading={loadingItems}
        getRowId={(row) => row.ref}
        {...props}
        sx={{
          paddingBottom: '160px',
          ...props.sx,
        }}
        paginationClassName="right-4"
      />
    </>
  );
};